"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCompletedOrders = exports.getCartSlot = exports.getCartCount = exports.deleteMultipleCartEntryNumber = exports.deleteCartEntryNumber = exports.deleteCart = exports.createCart = void 0;
exports.getHcCart = getHcCart;
exports.updateCartMapUser = exports.updateCart = exports.getUpcomingOrders = exports.getMainCartSlot = exports.getIndividualCartSlot = void 0;
var _genericFetch = _interopRequireWildcard(require("../../../common/api/genericFetch"));
var _ApiConst = require("../../../common/utils/ApiConst");
var _utils = require("../../../common/utils/utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function getHcCart(params, tokenData) {
  const queryParam = {
    zone: params === null || params === void 0 ? void 0 : params.zone
  };
  const query = (0, _utils.getQuery)(queryParam);
  const apiEndPoint = _ApiConst.HOMECARE_CART_API + params.cartId + query;
  let options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options = (0, _genericFetch.enhanceWithSesionIdAndUserId)(options, params === null || params === void 0 ? void 0 : params.userId);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
const updateCart = (params, tokenData) => {
  const requestBody = {
    quantity: params === null || params === void 0 ? void 0 : params.quantity,
    entryNo: params === null || params === void 0 ? void 0 : params.entryNo
  };
  const apiEndPoint = _ApiConst.HOMECARE_CART_API + params.cartId;
  let options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options = (0, _genericFetch.enhanceWithSesionIdAndUserId)(options, params === null || params === void 0 ? void 0 : params.userId);
  options.body = requestBody;
  options.method = _ApiConst.API_PARAMS.PUT;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
};
exports.updateCart = updateCart;
const updateCartMapUser = (params, tokenData) => {
  const apiEndPoint = _ApiConst.HOMECARE_CART_API + params.cartId + '/map-user';
  let options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options = (0, _genericFetch.enhanceWithSesionIdAndUserId)(options, params === null || params === void 0 ? void 0 : params.userId);
  options.method = _ApiConst.API_PARAMS.PUT;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
};
exports.updateCartMapUser = updateCartMapUser;
const createCart = (params, tokenData) => {
  const requestBody = {
    productId: params === null || params === void 0 ? void 0 : params.productId,
    productName: params === null || params === void 0 ? void 0 : params.productName,
    productDesc: params === null || params === void 0 ? void 0 : params.productDesc,
    quantity: params === null || params === void 0 ? void 0 : params.quantity,
    price: params === null || params === void 0 ? void 0 : params.price,
    startTime: params === null || params === void 0 ? void 0 : params.startTime,
    endTime: params === null || params === void 0 ? void 0 : params.endTime,
    cartType: params === null || params === void 0 ? void 0 : params.cartType
  };
  const apiEndPoint = _ApiConst.HOMECARE_CART_API;
  let options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options = (0, _genericFetch.enhanceWithSesionIdAndUserId)(options, params === null || params === void 0 ? void 0 : params.userId);
  options.body = requestBody;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
};
exports.createCart = createCart;
const deleteCart = (params, tokenData) => {
  const apiEndPoint = _ApiConst.HOMECARE_CART_API + params.cartId;
  let options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options = (0, _genericFetch.enhanceWithSesionIdAndUserId)(options, params === null || params === void 0 ? void 0 : params.userId);
  options.method = _ApiConst.API_PARAMS.DELETE;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
};
exports.deleteCart = deleteCart;
const deleteCartEntryNumber = (params, tokenData) => {
  const apiEndPoint = _ApiConst.HOMECARE_CART_API + params.cartId + '/' + params.entryNo;
  let options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options = (0, _genericFetch.enhanceWithSesionIdAndUserId)(options, params === null || params === void 0 ? void 0 : params.userId);
  options.method = _ApiConst.API_PARAMS.DELETE;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
};
exports.deleteCartEntryNumber = deleteCartEntryNumber;
const getCartCount = (params, tokenData) => {
  const apiEndPoint = _ApiConst.HOMECARE_CART_API + 'count?cartType=' + (params === null || params === void 0 ? void 0 : params.cartType);
  let options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options = (0, _genericFetch.enhanceWithSesionIdAndUserId)(options, params === null || params === void 0 ? void 0 : params.userId);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
};
exports.getCartCount = getCartCount;
const getCartSlot = (params, tokenData) => {
  const query = (0, _utils.getQuery)(params);
  const apiEndPoint = _ApiConst.HOMECARE_SEARCH_API + _ApiConst.HOMECARE_SLOT_CART + query;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
};
exports.getCartSlot = getCartSlot;
const getIndividualCartSlot = (params, tokenData) => {
  const query = (0, _utils.getQuery)(params);
  const apiEndPoint = _ApiConst.HOMECARE_SEARCH_API + _ApiConst.HOMECARE_MAIN_SLOT_CART + query;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
};
exports.getIndividualCartSlot = getIndividualCartSlot;
const getMainCartSlot = (params, tokenData) => {
  const query = (0, _utils.getQuery)(params);
  const apiEndPoint = _ApiConst.HOMECARE_SEARCH_API + _ApiConst.HOMECARE_MAIN_SLOT_CART + query;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
};
exports.getMainCartSlot = getMainCartSlot;
const deleteMultipleCartEntryNumber = (params, tokenData) => {
  const requestBody = (params === null || params === void 0 ? void 0 : params.itemIDs) || [];
  const apiEndPoint = _ApiConst.HOMECARE_CART_API + (params === null || params === void 0 ? void 0 : params.cartId) + '/delete';
  let options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options = (0, _genericFetch.enhanceWithSesionIdAndUserId)(options, params === null || params === void 0 ? void 0 : params.userId);
  options.body = requestBody;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
};
exports.deleteMultipleCartEntryNumber = deleteMultipleCartEntryNumber;
const getUpcomingOrders = (params, tokenData) => {
  const query = (0, _utils.getQuery)(params);
  const apiEndPoint = _ApiConst.HOMECARE_SEARCH_API + _ApiConst.GET_UPCOMING_ORDERS_URL + query;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
};
exports.getUpcomingOrders = getUpcomingOrders;
const getCompletedOrders = (params, tokenData) => {
  const query = (0, _utils.getQuery)(params);
  const apiEndPoint = _ApiConst.HOMECARE_SEARCH_API + _ApiConst.GET_SERVICE_COMPLETED_ORDERS + query;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
};
exports.getCompletedOrders = getCompletedOrders;